module.exports = __webpack_public_path__ + "static/media/gls_logo.03272f63.png";


//////////////////
// WEBPACK FOOTER
// ./static/gls_logo.png
// module id = 821
// module chunks = 1